import { useEffect } from "react";
import dayjs from "dayjs";

import { Table, Thead, Tbody, Tr, Th, Td } from "react-super-responsive-table";
import { getPeriodName } from "../../services/SchoolService";


const ActivityDetails = ({ school, activityDetails }) => {
  useEffect(() => {}, []);

  return (
    <Table style={{ marginTop: "1em", marginBottom: "1em" }}>
      <Thead>
        <Tr>
          <Th>Activity Name</Th>
          <Th>Date</Th>
          <Th>Period</Th>
          <Th>Owner</Th>
          <Th>Location</Th>
          <Th>Max #</Th>
        </Tr>
      </Thead>
      <Tbody>
        <Tr>
          <Td>{activityDetails.name}</Td>
          <Td>
            {dayjs(activityDetails.date).format("MM/DD")}
          </Td>
          <Td>{getPeriodName(school, activityDetails.period - 1)}</Td>
          <Td>{activityDetails.last_name}</Td>
          <Td>{activityDetails.locationName}</Td>
          <Td>{activityDetails.maxAttendance}</Td>
        </Tr>
      </Tbody>
    </Table>
  );
};

export default ActivityDetails;
